import React from 'react';
import {
	Center,
	Spinner
} from '@chakra-ui/react';

export default function CustomSpinner(){
    return <Center p="20"><Spinner thickness='4px' speed='0.65s' emptyColor='gray.200' color='gray.500' size='xl'/></Center>;
}
